import { landingPageContent } from '@content/landing-page'

export interface CallToActionProps {
  callToActionLink?: string
}

export function CallToAction({ callToActionLink }: CallToActionProps) {
  return (
    <section className='container mx-auto' id='cta'>
      <div className='px-5 py-14 lg:px-0'>
        <div className='m-2 flex w-full flex-col items-center justify-center gap-y-5 rounded-2xl border border-slate-500/20 bg-neutral-50 p-10 shadow-inner dark:bg-neutral-900'>
          <h3 className='max-w-2xl text-center text-2xl font-bold text-balance text-neutral-800 md:text-3xl lg:text-4xl dark:text-white'>
            {landingPageContent.callToAction.title}
          </h3>
          <p className='mx-auto text-center text-balance md:text-lg'>
            {landingPageContent.callToAction.description}
          </p>
          <a
            href={callToActionLink}
            rel='noopener noreferrer nofollow'
            target='_blank'
            className='shadow-small flex h-10 w-48 items-center justify-center gap-2.5 rounded-full border border-neutral-300/30 bg-neutral-900 font-medium text-white shadow-[4px_4px_0_0_rgba(0,0,0,0.9)] transition-all duration-150 active:translate-x-[2px] active:translate-y-[2px] active:scale-95 active:shadow-none'
          >
            {landingPageContent.callToAction.buttonText}
          </a>
        </div>
      </div>
    </section>
  )
}
